<div class="h-100 w-100 d-flex flex-fill">
	<article id="htmlViewer" class="html-viewer" appHasMarkedText></article>
</div>
